import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'absoluteValue',
    standalone: false
})
export class AbsoluteValuePipe implements PipeTransform {

  transform(num: number, args?: any): any {
    return Math.abs(num);
  }

}
